import AdminHeader from '../komponenter/admin/AdminHeader';
import AdminInquiryListSection from '../komponenter/admin/AdminInquiryListSection';
import AdminLoadingState from '../komponenter/admin/AdminLoadingState';
import AdminLoginSection from '../komponenter/admin/AdminLoginSection';
import AdminPropertyFormSection from '../komponenter/admin/AdminPropertyFormSection';
import AdminPropertyListSection from '../komponenter/admin/AdminPropertyListSection';
import AdminSettingsFormSection from '../komponenter/admin/AdminSettingsFormSection';
import { useAdminPage } from '../hooks/useAdminPage';

function AdminPage() {
  const {
    dashboardError,
    editingSlug,
    handleDeleteProperty,
    handleEditProperty,
    handleLoginSubmit,
    handleLogout,
    handlePropertySubmit,
    handleSettingsSubmit,
    imageUploadError,
    isLoading,
    isUploadingImage,
    loginError,
    loginForm,
    inquiries,
    propertyForm,
    removePropertyImage,
    resetPropertyForm,
    saveMessage,
    session,
    setLoginForm,
    setPropertyForm,
    setSettingsForm,
    settingsForm,
    sortedProperties,
    uploadPropertyImage,
  } = useAdminPage();

  if (isLoading) {
    return <AdminLoadingState />;
  }

  if (!session) {
    return <AdminLoginSection handleLoginSubmit={handleLoginSubmit} loginError={loginError} loginForm={loginForm} setLoginForm={setLoginForm} />;
  }

  return (
    <div className="min-h-screen bg-[linear-gradient(180deg,#f4efe6_0%,#eef3ec_100%)] text-[#183228]">
      <AdminHeader handleLogout={handleLogout} />

      <main className="mx-auto grid w-[min(1180px,calc(100%-40px))] gap-6 py-8 lg:grid-cols-[minmax(0,1.1fr)_minmax(360px,0.9fr)]">
        <AdminPropertyListSection
          dashboardError={dashboardError}
          handleDeleteProperty={handleDeleteProperty}
          handleEditProperty={handleEditProperty}
          saveMessage={saveMessage}
          sortedProperties={sortedProperties}
        />

        <aside className="grid gap-6">
          <AdminPropertyFormSection
            editingSlug={editingSlug}
            handlePropertySubmit={handlePropertySubmit}
            imageUploadError={imageUploadError}
            isUploadingImage={isUploadingImage}
            propertyForm={propertyForm}
            removePropertyImage={removePropertyImage}
            resetPropertyForm={resetPropertyForm}
            setPropertyForm={setPropertyForm}
            uploadPropertyImage={uploadPropertyImage}
          />
          <AdminSettingsFormSection handleSettingsSubmit={handleSettingsSubmit} setSettingsForm={setSettingsForm} settingsForm={settingsForm} />
          <AdminInquiryListSection inquiries={inquiries} />
        </aside>
      </main>
    </div>
  );
}

export default AdminPage;